import './idroflog.css';
import idroflog_img from '../../assets/idroflog.png';
import { GoDotFill } from 'react-icons/go';
import { useTranslation } from 'react-i18next';

function Idroflog() {
  const { t } = useTranslation('global');

  return (
    <section className="product-hero" aria-labelledby="idroflog-title">
      <div className="product-hero__copy">
        <p className="product-hero__kicker">BeoMedica</p>
        <h1 id="idroflog-title">{t('idroflog.title')}</h1>
        <h2 className="product-hero__subtitle">{t('idroflog.sub_title')}</h2>
        <p>{t('idroflog.paragraph_1')}</p>
        <ul className="product-hero__list">
          <li>
            <GoDotFill aria-hidden="true" /> {t('idroflog.list_item_1')}
          </li>
          <li>
            <GoDotFill aria-hidden="true" /> {t('idroflog.list_item_2')}
          </li>
        </ul>
        <p>{t('idroflog.paragraph_2')}</p>
      </div>
      <div className="product-hero__media">
        <img
          src={idroflog_img}
          alt={t('idroflog.image_alt', { defaultValue: 'Idroflog' })}
        />
      </div>
    </section>
  );
}

export default Idroflog;
